import React, { Component } from "react";
import { ConnectedRouter } from "connected-react-router";
import { history } from "@my-dld/reducers/store";
import AppContextWrapper, { AppContext } from "@my-dld/contexts/AppContext";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router";
import Dashboard from "./Dashboard";
import Login, { QueryHandler } from "../Login";
import Logout from "./Logout";
import Register from "../Register";
import PropertyDetails from "./PropertyDetails";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import AppMessage from "@my-dld/components/AppMessage";
import TWIMCForm from "../TabuRequest/TWIMCForm";
import TabuVoucherInfo from "../TabuRequest/TabuVoucherInfo";
import LossCertificateForm from "../TabuRequest/LossCertificateForm";
import PropertyValuationForm from "../TabuRequest/PropertyValuationForm";
import CompleteTabuRequest from "../TabuRequest/CompleteTabuRequest";
import SiteplanForm from "../TabuRequest/SiteplanForm";
import MyProfile from "./MyProfile";
import RequestDetails from "./MyRequest/RequestDetails";
import BreadCrumb from "@my-dld/components/BreadCrumb";
import PageContextWrapper from "@my-dld/contexts/PageContext";
import { SuccessRegister } from "../Register/SuccessRegister";
import SSONoApp from "../Login/sso/NoApp";
import SSORegister from "../Login/sso/register";
import SSOForgot from "../Login/sso/forgot";
import NewRequest from "./NewRequest";
import RTOnlineReg from "../RTRegistration";
import urlParser from "urijs";
import OwnerEjariServices from "@eres/ejari-web/screens/Owner";
import EjariContractServices from "@eres/ejari-web/screens/Contract";
import { clearLocalData } from "@10x/sso";
import OwnerLeased from "@eres/ejari-web/screens/Leased/OwnerLeased";
import { ToastContainer } from "react-toastify";
import I8N from "@eres/core/dist/I8N";
import TenantEjariServices from "@eres/ejari-web/screens/Tenant";
import TenantRequestDetail from "@eres/ejari-web/screens/Tenant/Requests/TenantRequestDetail";
import { appendPath } from "@my-dld/utils/PathUtils";
import OwnedProperties from "./Portfolio/OwnedProperties";
import LeasedProperties from "./Portfolio/LeasedProperties";
import MyTenantRequests from "@eres/ejari-web/screens/Tenant/Requests/MyTenantRequests";
import RequestsFromTenant from "@eres/ejari-web/screens/Tenant/Requests/RequestsFromTenant";
import { OwnerCommittee } from "../OwnerCommittee";
import AccountManagerInfo from "../VIPOwner";
import TabuRequests from "./MyRequest/TabuRequests";
import MyRequestsServices from "./MyRequest";
import RTRequests from "./MyRequest/RTRequests";
import OwnerCommitteeRequests from "./MyRequest/OwnerCommitteeRequests";
import RegisterRVSComplaint from "../RVS/RegisterRVSComplaint";
import ComplaintDetails from "./MyRequest/ComplaintDetails";
import MyComplaints from "./MyRequest/MyComplaints";
import ENocMollak from "../eNOCMollak";
import MollakServiceCharge from "../MollakServiceCharge";
import { ExternalValuation } from "../ExternalValuation";
import EVRequestDetails from "../ExternalValuation/EVRequestDetails";
import ExternalValuationRequests from "./MyRequest/ExternalValuationRequests";
import EnocMollakRequests from "./MyRequest/EnocMollakRequests";
import Vault from "@eres/dldvault/screens";

import MortgageQuotation from "../MortgageQuotation";
import MQRequests from "./MyRequest/MQRequests";
import { RDCCases } from "../RDCCases";
import { NavigationService } from "@10x/coreapp";
import { WebRegisterRouteOptions } from "@10x/coreapp/NavigationService";
import { UserNotificationHandleNavigation } from "@my-dld/utils/UserNotificationHandler";
import PrivateSell, { MyRequestPrivateSell } from "../PrivateSell";
import BcsReClassificationFrom from "../TabuRequest/BcsReClassificationFrom";
import PropertyDocuments from "./ProcedureArchives";
import OwnershipChangeForm, { DelayedPropertyCutOffForm, PropertyCutOffForm } from "../TabuRequest/OwnershipChangeFrom";
import { ITabuSmartService, TabuRequestUtils } from "@10x/tabu-mobile-api";
import { ProcedureIDs } from "@10x/tabu-mobile-api/dist/requests/entity";
import { MyRequestServices } from "@my-dld/utils/TabuUtils";
import PropertyAllPhotos from "./PropertyAllPhotos";
import { DelayedPropertyAnnexForm, PropertyAnnexForm } from "../TabuRequest/AnnexForms";
import TabuRequestCW, { TabuRequestContext } from "@my-dld/contexts/TabuRequestContext";
import PropertyPicker from "@my-dld/components/PropertyPicker";
import MultiPropertiesForm from "../TabuRequest/MultiPropertiesForm";
import { PropertyCoOccupants } from "@eres/ejari-web/screens/ManageCoOccupant";
import ManagementContract from "@eres/ejari-web/screens/ManagementContract";
import ManagementContractRequests from "@eres/ejari-web/screens/ManagementContract/Requests/ManagementContractRequests";
import JOPServices from "../JOPServices";
import JOPRequests from "../JOPServices/JOPRequests";
import JOPServicesSelection from "../JOPServices/JOPServicesSelection";
import AppProfiles from "./AppProfiles";
import ProfileNDA from "./ProfileNDA";

class Index extends Component {

	render() {
		window.hasMyDLD = true;
		let uri = urlParser( window.location.href );
		let q = uri.query( true ) as any;
		if ( Object.keys( q ).length > 0 ) {
			const nl = uri.clone();
			nl.removeQuery( q );
			window.location.replace( nl.href() + "?" + uri.query() );
			return <></>;
		}
		return <ConnectedRouter history={ history }>
			<ToastContainer
				position="top-center"
				autoClose={ 5000 }
				hideProgressBar={ false }
				newestOnTop={ false }
				closeOnClick
				rtl={ I8N.isRTL() }
				pauseOnFocusLoss
				draggable
				pauseOnHover/>
			<AppContextWrapper componentId={ "mydld" }>
				<QueryHandler/>
				<Route path="/mydld" component={ MyDLD }/>
				<Route path="/login" component={ Login }/>
				<Route path="/logout/:from?" component={ Logout }/>
				<Route path="/register/success/:id" component={ SuccessRegister }/>
				<Route path="/sso/noapp/:appId" component={ SSONoApp }/>
				<Route path="/sso/register" component={ SSORegister }/>
				<Route path="/sso/forgot" component={ SSOForgot }/>
				<Route path="/register" component={ Register }/>
				<AppMessage/>
			</AppContextWrapper>
		</ConnectedRouter>;
	}
}

class MyDLD extends Component<RoutedViewProps> {
	static contextType = AppContext;
	context!: React.ContextType<typeof AppContext>;

	render() {
		const pp = this.props.match.url;
		if ( this.context.user == null ) {
			clearLocalData();
			return <Redirect to={ "/login" }/>;
		}
		const notif = UserNotificationHandleNavigation( this.props.location.pathname );
		if ( notif ) return notif;
		return <PageContextWrapper>
			<React.Fragment>
				<Switch>
					<Route component={ BreadCrumb }/>
				</Switch>
				<Switch>
					<Route path={ [ pp ] } exact={ true }>
						<Redirect to={ appendPath( pp, "/dashboard" ) }/>
					</Route>
					<Route path={ appendPath( pp, "/profiles" ) } component={ AppProfiles }/>
					<Route path={ appendPath( pp, "/nda" ) } component={ ProfileNDA }/>
					<Route path={ appendPath( pp, "/dashboard" ) } component={ Dashboard }/>
					<Route path={ appendPath( pp, "/vault" ) } component={ Vault }/>
					<Route path={ appendPath( pp, "/owned/:proxyId?" ) } component={ OwnedProperties }/>
					<Route path={ appendPath( pp, "/my_leases" ) } component={ LeasedProperties }/>
					<Route
						path={ appendPath( pp, "/property/:propertyTypeId/:propertyId/ejarisvc" ) }
						component={ OwnerEjariServices }/>
					<Route
						path={ appendPath( pp, "/ejari/contract" ) }
						component={ EjariContractServices }/>
					<Route
						path={ appendPath( pp, "/ejari/management-contract" ) }
						component={ ManagementContract }/>
					<Route
						path={ appendPath( pp, "/property/:propertyTypeId/:propertyId/documents" ) }
						component={ PropertyDocuments }/>
					<Route
						path={ appendPath( pp, "/property/:propertyTypeId/:propertyId/photos" ) }
						component={ PropertyAllPhotos }/>

					<Route
						path={ appendPath( pp, "/property/:propertyTypeId/:propertyId/:isFreeHold/cooccupants" ) }
						component={ PropertyCoOccupants }/>
					<Route
						path={ [ appendPath( pp, "/property/:propertyTypeId/:propertyId/:hideServices" ),
							appendPath( pp, "/property/:propertyTypeId/:propertyId" ) ] }>
						<TabuRequestCW>
							<Route component={ PropertyDetails }/>
						</TabuRequestCW>
					</Route>
					<Route path={ appendPath( pp, "/taburequest" ) } component={ TabuRequest }>
						<TabuRequestCW>
							<Route component={ TabuRequest }/>
						</TabuRequestCW>
					</Route>
					<Route path={ appendPath( pp, "/profile" ) } component={ MyProfile }/>
					<Route path={ appendPath( pp, "/rt" ) } component={ RTOnlineReg }/>
					<Route path={ appendPath( pp, "/leased" ) } component={ OwnerLeased }/>
					<Route
						path={ appendPath( pp, "/tenant/request/:userTypeId/:contractTypeId/:contractId" ) }
						component={ TenantRequestDetail }/>
					<Route path={ appendPath( pp, "/tenant" ) } component={ TenantEjariServices }/>
					<Route path={ appendPath( pp, "/my_tenancy_requests" ) } component={ MyTenantRequests }/>
					<Route path={ appendPath( pp, "/requests_from_tenant" ) } component={ RequestsFromTenant }/>
					<Route path={ appendPath( pp, "/management_contract_requests" ) } component={ ManagementContractRequests }/>
					<Route path={ pp + "/owner_committee" } component={ OwnerCommittee }/>
					<Route path={ appendPath( pp, "/account_manager" ) } component={ AccountManagerInfo }/>
					<Route
						path={ appendPath( pp, "/my_requests" ) } exact={ true }
						component={ MyRequestsServices }/>
					<Route
						path={ appendPath( pp, "/my_requests/tabu/:procedureId" ) } exact={ true }
						component={ TabuRequests }/>
					<Route path={ appendPath( pp, "/my_requests/tabu/:procedureId/:procedureNumber/:procedureYear" ) }>
						<TabuRequestCW>
							<Route component={ RequestDetails }/>
						</TabuRequestCW>
					</Route>
					<Route path={ appendPath( pp, "/my_requests/rt" ) } component={ RTRequests }/>
					<Route
						path={ appendPath( pp, "/my_requests/owner_committee" ) }
						component={ OwnerCommitteeRequests }/>
					<Route
						path={ appendPath( pp, "/my_requests/complaints" ) }
						component={ MyComplaints }/>
					<Route path={ appendPath( pp, "/rvs" ) } component={ RegisterRVSComplaint }/>
					<Route
						path={ appendPath( pp, "/mycomplaint/:requestKey/:showDownload" ) }
						component={ ComplaintDetails }/>
					<Route path={ appendPath( pp, "/mollak_service_charges" ) } component={ MollakServiceCharge }/>
					<Route path={ pp + "/external_valuation" } component={ ExternalValuation }/>
					<Route path={ pp + "/valuation_details/:requestId" } component={ EVRequestDetails }/>
					<Route
						path={ appendPath( pp, "/my_requests/external_valuation" ) }
						component={ ExternalValuationRequests }/>
					<Route
						path={ appendPath( pp, "/mortgage_quotation/:propertyTypeId/:propertyId" ) }
						component={ MortgageQuotation }/>
					<Route path={ appendPath( pp, "/my_requests/mortgage_quotation" ) } component={ MQRequests }/>
					<Route path={ pp + "/rdc_cases" } component={ RDCCases }/>
					<Route path={ appendPath( pp, "/enocm" ) } component={ ENocMollak }/>
					<Route
						path={ appendPath( pp, "/my_requests/enoc_mollak" ) }
						component={ EnocMollakRequests }/>
					<Route
						path={ appendPath( pp, "/my_requests/privateSell" ) }
						component={ MyRequestPrivateSell }/>
					<Route
						path={ appendPath( pp, "/privateSell" ) }
						component={ PrivateSell }/>
					<Route
						path={ appendPath( pp, "/jop/requests/:id/:requestId" ) }
						render={ props => <JOPRequests { ...props } detailView={ true }/> }/>
					<Route
						path={ appendPath( pp, "/jop/requests/:id" ) } component={ JOPRequests }/>
					<Route
						path={ appendPath( pp, "/jop/requests" ) } render={ props => <JOPServicesSelection { ...props } isRequests={ true }/> }/>
					<Route
						path={ appendPath( pp, "/jop" ) }
						component={ JOPServices }/>
					<MyDLDRoute pp={ pp } routes={ NavigationService.routes }/>
				</Switch>
			</React.Fragment>
		</PageContextWrapper>;
	}
}

function MyDLDRoute( props: { pp: string; routes: WebRegisterRouteOptions[] } ) {
	const { routes, pp } = props;
	const xRoutes = routes.map( ( x: WebRegisterRouteOptions ) => x.myDLD )
	.filter( x => x != null );
	return <>
		{ xRoutes
		.map( route => {
			const { path, ...others } = route!;
			let p: string[] | undefined = undefined;
			if ( Array.isArray( path ) ) {
				p = path.map( iPath => appendPath( pp, iPath ) );
			} else if ( path ) {
				p = [ appendPath( pp, path as string ) ];
			}
			return <Route path={ p } { ...others } key={ p?.join( "-" ) }/>;
		} )
		}
	</>;
}

class TabuRequest extends Component<RoutedViewProps> {
	static contextType = TabuRequestContext;
	context!: React.ContextType<typeof TabuRequestContext>;

	render() {
		const pp = this.props.match.url;
		return <Switch>
			<Route path={ pp + "/new" } component={ NewRequest }/>
			{ MyRequestServices.map( ( value ) => {
				const rt = ToTabuServiceRoute( value );
				if ( rt.component || rt.render ) {
					const ps = "/" + TabuRequestUtils.tabuProcedureIdString( value.Id );
					const paths = [ pp + ps, pp + "/edit" + ps ];
					return <Route
						key={ value.Id }
						path={ paths }
						component={ rt.component } render={ rt.render }/>;
				}
				return null;
			} ) }
			<Route path={ pp + "/voucher" } component={ TabuVoucherInfo }/>
			<Route path={ pp + "/complete" } component={ CompleteTabuRequest }/>
			<Route path={ `${ pp }/:serviceId/properties` } component={ MultiPropertiesForm }/>
			<Route
				path={ `${ pp }/:serviceId/add_properties` }
				render={ () => <PropertyPicker
					property={ this.context.property }
					properties={ this.context.properties }
					onContinue={ properties => {
						this.context.addProperties( properties );
						this.props.history.goBack();
					} }/> }/>
		</Switch>;
	}
}

type TabuServiceRouteInfo = {
	component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined;
	render: ( ( props: RouteComponentProps<any> ) => React.ReactNode ) | undefined;
}

function ToTabuServiceRoute( service: ITabuSmartService ): TabuServiceRouteInfo {
	let component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined = undefined;
	let render: ( ( props: RouteComponentProps<any> ) => React.ReactNode ) | undefined = undefined;
	switch ( service.Id as ProcedureIDs ) {
		case ProcedureIDs.ELECTRONIC_TITLE_DEED:
			break;
		case ProcedureIDs.LOSS_CERTIFICATE:
			component = LossCertificateForm;
			break;
		case ProcedureIDs.SITE_PLAN:
			component = SiteplanForm;
			break;
		case ProcedureIDs.PROPERTY_VALUATION:
			component = PropertyValuationForm;
			break;
		case ProcedureIDs.INTERNAL_PROPERTY_VALUATION:
			render = ( props ) => <PropertyValuationForm { ...props } isInternal={ true }/>;
			break;
		case ProcedureIDs.TO_WHOM_CONCERN:
			component = TWIMCForm;
			break;
		case ProcedureIDs.PROPERTY_DETAIL_CERT:
			render = ( props ) => <TWIMCForm { ...props } isPropertyLevel={ true }/>;
			break;
		case ProcedureIDs.BCS_RE_CLASSIFICATION:
			component = BcsReClassificationFrom;
			break;
		case ProcedureIDs.OWNERSHIP_CHANGE:
			component = OwnershipChangeForm;
			break;
		case ProcedureIDs.PROPERTY_CUT_OFF:
			component = PropertyCutOffForm;
			break;
		case ProcedureIDs.DELAYED_PROPERTY_CUT_OFF:
			component = DelayedPropertyCutOffForm;
			break;
		case ProcedureIDs.PROPERTY_ANNEX:
			component = PropertyAnnexForm;
			break;
		case ProcedureIDs.DELAYED_PROPERTY_ANNEX:
			component = DelayedPropertyAnnexForm;
			break;
	}
	return { component, render };
}

export default Index;
